import { MIcon } from '../../components/@material-extend';

export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      defaultProps: {
        popupIcon: <MIcon icon="keyboard_arrow_down" fontSize={20} />
      },
      styleOverrides: {
        root: {
          UserSelect: 'none !important',
          '.MuiChip-label': {
            // Limite la largeur des Chip qui sont dans les Autocomplete multiline
            // (ex : filtersResources ou filtersSites)
            maxWidth: 200
          }
        },
        paper: {
          boxShadow: theme.customShadows.z20
        }
      }
    }
  };
}
